import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { filtroEstados } from "../../helper/ordenHelper";
import { fetchSellers, fetchSellersFilter } from '../../actions/sellersActions';
import { DropDownArrow, customStyle } from "../../template/CustomStyle";
import { limpiarFiltros } from '../../actions/generalActios';
import { filtroMedioMes } from '../../utilities/fechasFiltro';
const fechaFiltro = filtroMedioMes();

class FiltroOrdenes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            numeroPagina: 1,
            cantidadPagina: 10,
            entidadOrdenamiento: 1,
            idSeller: "",
            idOrden: "",
            documento: "",
            nombre: "",
            apellido: "",
            fechaDesde: "",
            fechaHasta: "",
            idEstado: "",
            seller: { label: "", value: "" },
            estado: { label: "", value: "" },
            sellers: [],
        }
    };

    componentDidMount() {
        const { filtro } = this.props;
        this.setState({
            fechaDesde: filtro.fechaDesde != undefined ? filtro.fechaDesde : fechaFiltro.desde,
            fechaHasta: filtro.fechaHasta != undefined ? filtro.fechaHasta : fechaFiltro.hasta,
            idSeller: filtro.idSeller,
            cantidadPagina: 10,
            numeroPagina: 1,
            idOrden: filtro.idOrden != undefined ? filtro.idOrden : "",
            documento: filtro.documento,
            nombre: filtro.nombre,
            apellido: filtro.apellido,
            idEstado: filtro.idEstado,
            seller: {
                label: filtro.seller != undefined ? filtro.seller.label : "",
                value: filtro.seller != undefined ? filtro.seller.value : ""
            },
            estado: {
                label: filtro.estado != undefined ? filtro.estado.label : "",
                value: filtro.estado != undefined ? filtro.estado.value : ""
            }
        });
    }

    componentDidUpdate(prevProps) {
        const { filtro } = this.props;
        if (filtro !== prevProps.filtro) {
            this.setState({
                fechaDesde: filtro.fechaDesde != undefined ? filtro.fechaDesde : fechaFiltro.desde,
                fechaHasta: filtro.fechaHasta != undefined ? filtro.fechaHasta : fechaFiltro.hasta,
                idSeller: filtro.idSeller,
                cantidadPagina: 10,
                numeroPagina: 1,
                idOrden: filtro.idOrden != undefined ? filtro.idOrden : "",
                documento: filtro.documento,
                nombre: filtro.nombre,
                apellido: filtro.apellido,
                idEstado: filtro.idEstado,
                seller: {
                    label: filtro.seller != undefined ? filtro.seller.label : "",
                    value: filtro.seller != undefined ? filtro.seller.value : ""
                },
                estado: {
                    label: filtro.estado != undefined ? filtro.estado.label : "",
                    value: filtro.estado != undefined ? filtro.estado.value : ""
                }
            });
        }
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    onSubmit = async (event) => {
        event.preventDefault();
        this.props.limpiarFiltros({
            publicaciones: true,
            ordenes: false,
            sellers: true,
        });

        this.props.updateRequest(this.state);
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
        if (config.name === "estado") {
            this.setState({ idEstado: options.value });
        }
        if (config.name === "seller") {
            this.setState({ idSeller: options.value });
        }
    }

    onSelectSearchInputSellers = (descripcion) => {
        this.props.fetchSellersFilter({ descripcion });
    }

    verTodos = () => {
        this.onSelectSearchInputSellers(null);

        this.setState({
            idSeller: "",
            estado: { label: "", value: "" },
            seller: { label: "", value: "" },
            idOrden: "",
            documento: "",
            nombre: "",
            apellido: "",
            idEstado: "",
            idOrden: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta
        });

        let params = {
            idSeller: "",
            idOrden: "",
            documento: "",
            nombre: "",
            apellido: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            idEstado: "",
            cantidadPagina: 10,
            numeroPagina: 1,
            entidadOrdenamiento: 1
        }

        this.props.updateRequest(params);
    }

    mapSellers = () => {
        let opcionTodos = { value: "", label: "Todos" };
        this.props.sellers.unshift(opcionTodos);
    }


    render() {
        let listaSeller = [];
        if (this.props.sellers != undefined) {
            this.props.sellers.map((item) => {
                listaSeller.push({ label: item.label, value: item.value.toString() })
            })
        }

        return (
            <form 
                className="card card-body filter-card"
                onSubmit={this.onSubmit}
                onReset={this.verTodos}
            >
                <div className="row form-material">

                    {this.props.allowSearchBySeller &&
                        <div className="col-lg-2">
                            <label className="label-oscura">Sellers</label>
                            <Select
                                name="seller"
                                value={this.state.seller}
                                options={listaSeller}
                                onChange={this.selectSearchHandler}
                                onMenuOpen={this.mapSellers}
                                onInputChange={this.onSelectSearchInputSellers}
                                components={{ DropdownIndicator: () => DropDownArrow }}
                                styles={customStyle}
                            />
                        </div>
                    }

                    <div className="col-lg-2">
                        <label className="label-oscura">Estados</label>
                        <Select
                            name="estado"
                            value={this.state.estado}
                            options={filtroEstados}
                            onChange={this.selectSearchHandler}
                            components={{ DropdownIndicator: () => DropDownArrow }}
                            styles={customStyle}
                        />
                    </div>

                    <div className="col-lg-1">
                        <label className="label-oscura">Orden</label>
                        <input
                            type="number"
                            name="idOrden"
                            className="form-control"
                            value={this.state.idOrden == null ? "" : this.state.idOrden}
                            onChange={this.myChangeHandler}
                        />
                    </div>

                    <div className="col-lg-1">
                        <label className="label-oscura">DNI</label>
                        <input
                            type="number"
                            name="documento"
                            className="form-control"
                            value={this.state.documento == null ? "" : this.state.documento}
                            onChange={this.myChangeHandler}
                        />
                    </div>

                    <div className="col-lg-2">
                        <label className="label-oscura">Apellido</label>
                        <input
                            type="text"
                            name="apellido"
                            className="form-control"
                            value={this.state.apellido == null ? "" : this.state.apellido}
                            onChange={this.myChangeHandler}
                        />
                    </div>

                    <div className="col-lg-2">
                        <label className="label-oscura">Fecha desde</label>
                        <input
                            type="date"
                            name="fechaDesde"
                            className="form-control"
                            value={this.state.fechaDesde}
                            onChange={this.myChangeHandler}
                        />
                    </div>

                    <div className="col-lg-2">
                        <label className="label-oscura">Fecha hasta</label>
                        <input
                            type="date"
                            name="fechaHasta"
                            className="form-control"
                            value={this.state.fechaHasta}
                            onChange={this.myChangeHandler}
                        />
                    </div>

                </div>

                <div className="row p-10">
                    <div className="col-lg-12 col-md-12 col-sm-12 ">
                        <button
                            className="btn d-inline btn-sm btn-grey m-r-10"
                            disabled={this.props.loadingOrdenes}
                            type='submit'
                        >
                            Buscar
                        </button>
                        <button 
                            className="btn btn-sm btn-grey d-inline"
                            type='reset'
                        >
                            Limpiar
                        </button>
                    </div>
                </div>

            </form>
        );
    }
}


const mapStateToProps = state => ({
    loadingOrdenes: state.ordenes.loadingOrdenes,
    sellers: state.sellers.filteredSellers,
});

export default connect(mapStateToProps, {
    fetchSellers,
    fetchSellersFilter,
    limpiarFiltros
})(FiltroOrdenes);